import { useState, useEffect } from 'react';
import { useCategories } from '../../hooks/useCategories';
import { useExpertList } from '../../hooks/expertListHooks/useExpertList';
import { FeaturedExperts } from '../experts/FeaturedExperts';

export function FeaturedExpertsHomepage() {
  const { categories, loading: categoriesLoading, error: categoriesError } = useCategories();
  const [activeCategory, setActiveCategory] = useState('');
  const [viewAll, setViewAll] = useState(false);

  // Auto-select the first category when it loads
  useEffect(() => {
    if (categories.length > 0 && !activeCategory) {
      // ✅ FIX 1: Removed .category_name to respect your Category type
      setActiveCategory(categories[0].name || '');
    }
  }, [categories, activeCategory]);

  // Fetch the experts dynamically using the active category
  // ✅ FIX 2: Removed 'page', 'limit', etc. to respect your GetExpertsFilterParams type
  const { featuredExperts, loading: expertsLoading, error: expertsError } = useExpertList({
    category: activeCategory
  } as any); 

  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-3xl sm:text-4xl text-gray-900">
              Featured Experts
            </h2>
            <p className="text-gray-600">
              Top-rated professionals you can trust
            </p>
          </div>

          <button
            onClick={() => setViewAll((prev) => !prev)}
            className="text-brand-blue-900 font-medium hover:underline"
            disabled={categoriesLoading}
          >
            {viewAll ? 'Show Featured' : 'View All'}
          </button>
        </div>

        {/* Categories */}
        <div className="flex flex-wrap gap-2 mb-6">
          {categoriesLoading ? (
            Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-10 w-24 bg-gray-200 animate-pulse rounded-xl"></div>
            ))
          ) : (
            categories.map((category) => {
              // ✅ FIX 1 applied here too
              const catName = category.name;
              return (
                <button
                  key={catName}
                  onClick={() => {
                    setActiveCategory(catName);
                    setViewAll(false);
                  }}
                  className={`px-4 py-2 rounded-xl text-sm transition ${
                    activeCategory === catName
                      ? 'bg-brand-blue-900 text-white'
                      : 'bg-white border border-gray-200 text-gray-700 hover:border-brand-blue-900'
                  }`}
                >
                  {catName}
                </button>
              );
            })
          )}
        </div>

        {/* Error Message */}
        {categoriesError && (
          <div className="mb-4 text-center">
            <p className="text-sm text-red-600">
              Unable to load categories. Mr. Developer working on it.
            </p>
          </div>
        )}

        {/* Your Reusable Component */}
        <div className="mt-4">
          <FeaturedExperts 
            experts={featuredExperts} 
            title="" 
            loading={expertsLoading} 
            error={!!expertsError} 
          />
        </div>

      </div>
    </section>
  );
}